module.exports = __webpack_public_path__ + "img/pestanas-2.2f14ef79.svg";